import React, { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import MenuBar from './MenuBar';
import './CreatorStudio.css';

function CreatorStudio({ setIsModalOpen }) {
  const editor = useEditor({
    extensions: [
      StarterKit,
    ],
    content: '<p>Start writing your masterpiece...</p>',
  });

  useEffect(() => {
    if (editor) {
      // You can add any editor-related side effects here.
    }
  }, [editor]);

  const handlePublish = () => {
    if (editor) {
      console.log('Publishing content:', editor.getHTML());
      setIsModalOpen(true);
    }
  };

  if (!editor) {
    return null;
  }

  return (
    <div className="creator-studio">
      <h2>Creator Studio</h2>
      <p className="editor-subtitle">Unleash your story.</p>
      <div className="editor-container">
        <MenuBar editor={editor} />
        <EditorContent editor={editor} />
      </div>
      <button className="publish-button" onClick={handlePublish}>Publish</button>
    </div>
  );
}

export default CreatorStudio;